document.addEventListener('DOMContentLoaded', () => {
  const variantPicker = document.querySelector('[data-variant-picker]');
  const priceElement = document.querySelector('[data-product-price]');
  const comparePriceElement = document.querySelector('[data-compare-price]');
  const addToCartButton = document.querySelector('[data-add-to-cart]');
  const productImage = document.querySelector('[data-product-image]');

  if (!variantPicker) {
    console.error('Variant picker not found on the page. Please check the HTML structure.');
    return;
  }

  // Précharger les données des variantes
  if (typeof Shopify !== 'undefined' && window.productVariants) {
    window.productVariants = window.productVariants;
  } else {
    console.error('Product variant data not found.');
    return;
  }

  // Écouter les changements de variantes
  variantPicker.addEventListener('change', (event) => {
    const selectedVariantId = event.target.value;
    const selectedVariant = window.productVariants.find(
      (variant) => variant.id == selectedVariantId
    );

    if (!selectedVariant) {
      console.error('Selected variant not found.');
      return;
    }

    // Mettre à jour le prix
    if (priceElement) {
      priceElement.textContent = Shopify.formatMoney(selectedVariant.price);
    }

    // Mettre à jour le prix comparatif
    if (comparePriceElement) {
      comparePriceElement.textContent = selectedVariant.compare_at_price
        ? Shopify.formatMoney(selectedVariant.compare_at_price)
        : '';
    }

    // Activer ou désactiver le bouton Ajouter au panier
    if (addToCartButton) {
      if (selectedVariant.available) {
        addToCartButton.removeAttribute('disabled');
      } else {
        addToCartButton.setAttribute('disabled', 'disabled');
      }
    }

    // Mettre à jour l'image du produit
    if (productImage && selectedVariant.featured_image) {
      productImage.src = selectedVariant.featured_image.src;
      productImage.alt = selectedVariant.title;
    }
  });
});
